import servicesUtils from "../../../utils/servicesUtils";
var getEmrWorkspace = function getEmrWorkspace(workspaceId) {
  return servicesUtils.getService("/emr/workspaces/".concat(workspaceId, "/"));
};
export default getEmrWorkspace;